import { extractData } from "../utils";
const hashes = extractData(document.getElementById('hashes-data'));
export function hash(key) {
    return hashes[key];
}
